module.exports = __webpack_public_path__ + "img/learn.f5dd950d.png";